import { useMemo } from 'react';

import { BindingCreator, createTranslatedText } from '@dreryk/react-common';
import { Select, StyledMaxWidth } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../../translations';

import { generateRangeOfYears } from './ReportingPeriodSelect.utils';

const REPORTING_PERIOD_SELECT_FIELD_NAME = 'year';
const START_YEAR = 2024;
const LAST_YEAR = new Date().getFullYear() - 1;

export type ReportingPeriodSelectFieldValue = {
   [REPORTING_PERIOD_SELECT_FIELD_NAME]: number;
};

type ReportingPeriodSelectProps = {
   readonly register: BindingCreator<ReportingPeriodSelectFieldValue, typeof REPORTING_PERIOD_SELECT_FIELD_NAME>;
};

export const ReportingPeriodSelect = (props: ReportingPeriodSelectProps): JSX.Element => {
   const items = useMemo(() => generateRangeOfYears(START_YEAR, LAST_YEAR), []);

   return (
      <StyledMaxWidth maxWidth={'90px'}>
         <Select<number>
            controller={props.register(REPORTING_PERIOD_SELECT_FIELD_NAME)}
            testId={REPORTING_PERIOD_SELECT_FIELD_NAME}
            label={statisticsTranslationKeys.formFields.reportingPeriod.label}
            triggerLabelExtractor={(item) => item.toString()}
         >
            <Select.List items={items}>
               {(item: number) => (
                  <Select.Item<number> item={item} testId={item} label={createTranslatedText(item.toString())} />
               )}
            </Select.List>
         </Select>
      </StyledMaxWidth>
   );
};
